
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { motion, MotionConfig } from "framer-motion"
import './ServiceCard.scss'


export default function ActionAreaCard({ img_path, title, description }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }}
      className='card-grid'
    >
      <Card className='root_card' sx={{ maxWidth: 400 }}>
        <div className='card_area'>
          <CardMedia
            component="img"
            height="220"
            image={`/images/${img_path}.jpg`}
            alt={title}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {title}
            </Typography>
            <Typography variant="body2">
              {description}
            </Typography>
          </CardContent>
        </div>
      </Card>
    </motion.div>
  );
}